import { Reveal, Stagger, staggerItem } from "../components/Reveal";
import { motion } from "framer-motion";
import { BENEFITS } from "../data/content";

export default function Beneficios() {
  return (
    <section id="beneficios" data-testid="beneficios-section" className="py-24 md:py-36 bg-[#2D3732]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-3xl mb-16">
          <p className="overline mb-6 text-[#A3B18A]">
            <span className="text-[#D7C6A3]">06</span> &nbsp;/&nbsp; Beneficios
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-white leading-tight">
            ¿Por qué elegir VITAE?
          </h2>
        </Reveal>

        <Stagger className="divide-y divide-white/10 border-y border-white/10">
          {BENEFITS.map(({ text, Icon }, i) => (
            <motion.div
              key={i}
              variants={staggerItem}
              data-testid={`benefit-${i}`}
              className="group flex items-center gap-6 md:gap-10 py-7 md:py-9"
            >
              <span className="font-display text-2xl md:text-4xl text-white/25 w-14 md:w-20 flex-shrink-0">
                0{i + 1}
              </span>
              <Icon
                size={30}
                weight="light"
                className="text-[#A3B18A] flex-shrink-0 group-hover:scale-110 transition-transform duration-500"
              />
              <p className="font-display text-2xl md:text-4xl text-white/90 leading-snug font-light">
                {text}
              </p>
            </motion.div>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
